import { useTranslation } from 'react-i18next';
import { DEFAULT_LOCALE, Locale, SUPPORTED_LOCALES } from '~app/i18n';

const stringIsLocale = (str: string): str is Locale => {
  return SUPPORTED_LOCALES.includes(str as Locale);
};

// Collapse any raw i18next language (`en-US`, a stale value, undefined) to a
// supported Locale. Exported so non-hook callers (route loaders) key the
// session query cache identically to useLocale() — otherwise their setQueryData
// lands under a key useSession() never reads.
export const normalizeLocale = (locale: string | undefined): Locale =>
  locale && stringIsLocale(locale) ? locale : DEFAULT_LOCALE;

export const useLocale = (): Locale => {
  const {
    i18n: { language: locale },
  } = useTranslation();

  return normalizeLocale(locale);
};
